import "./components.css";

export const Spinner = () => {
  return (
    <div>
      <div>
        <h2 className="text-xl font-bold mb-4 text-center">
          Cargando Información...
        </h2>
      </div>
      <div className="flex justify-center items-center ">
        <div className="w-32 h-32 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
      </div>
    </div>
  );
};
